import React from 'react';
import { AccountView } from './AccountView';
export const AccountContainer = () => {
    return React.createElement(AccountView, null);
};
export default AccountContainer;
